// extracted by mini-css-extract-plugin
module.exports = {"refund-block":"refund_refund-block__1EJP9","refund-stats":"refund_refund-stats__2KAWM"};